// Modal "Cambiar cantidad pedida" — variante m del mockup de Fase 1,
// implementado en sub-fase 7.3.
//
// Stepper +/- con teclado numérico fallback. Resuelve con la cantidad
// nueva (number, puede ser 0 = eliminar) o `undefined` si cancela.

import { icon } from './icons.js';

const escapeHtml = (s) => String(s ?? '').replace(/[&<>"']/g,
  c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

let _host = null;
function _close() { if (_host) { _host.remove(); _host = null; } }

export function openEditarLineaModal({ linea }) {
  return new Promise((resolve) => {
    _host = document.createElement('div');
    document.body.appendChild(_host);

    let cantidad = linea.cantidad_pedida;
    const ref = escapeHtml(linea.barcode || `#${linea.producto_id}`);
    const desc = escapeHtml(linea.descripcion);

    function render() {
      _host.innerHTML = `
        <div class="scrim fade-in"><div class="modal">
          <h2>${icon('pencil', { size: 22 })} Cambiar cantidad</h2>
          <div class="prod-card">
            <div class="ref">${ref}</div>
            <div class="desc">${desc}</div>
            <div class="meta">Cantidad original: ${linea.cantidad_pedida}</div>
          </div>
          <div class="field">
            <label for="el-input">Nueva cantidad</label>
            <div class="stepper">
              <button data-step="-1" aria-label="Restar">−</button>
              <input id="el-input" type="number" inputmode="numeric" min="0" value="${cantidad}">
              <button data-step="+1" aria-label="Sumar">+</button>
            </div>
          </div>
          <p class="hint">Si bajas la cantidad por debajo de lo ya empaquetado en cajas, el sistema te avisará para que edites/anules esas cajas primero.</p>
          <div class="actions">
            <button class="btn --ghost" id="el-cancel">Cancelar</button>
            <button class="btn --primary" id="el-save">Guardar</button>
          </div>
        </div></div>`;

      const input = _host.querySelector('#el-input');
      setTimeout(() => input.focus(), 50);
      input.addEventListener('input', () => {
        const v = parseFloat(input.value);
        if (Number.isFinite(v) && v >= 0) cantidad = v;
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') _host.querySelector('#el-save').click();
      });

      _host.querySelectorAll('button[data-step]').forEach(b => {
        b.addEventListener('click', () => {
          const delta = parseInt(b.dataset.step, 10);
          cantidad = Math.max(0, cantidad + delta);
          input.value = cantidad;
        });
      });

      _host.querySelector('#el-cancel').addEventListener('click', () => { _close(); resolve(undefined); });
      _host.querySelector('#el-save').addEventListener('click', () => {
        _close();
        resolve(cantidad);
      });
    }

    render();
  });
}
